<template>
    <div class="modal modal--center show" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="login__figure">
                        <div class="login__logo" style="text-align: center;">
                            <a href="https://www.kpi.com/">
                                <img src="https://apps.kpi.com/mainStyles/new-ui/images/new-kpi-logo.svg" alt="kpi.com">
                            </a>
                        </div>
                        <div class="login__caption"> Manage your business from a single platform.</div>
                    </div>
                </div>
                <div v-if="COMPANIES">
                    <button v-for="company in COMPANIES"
                            @click.prevent="loginByCompany(company.company_id)"
                            class="login__company" :key="company.company_id" type="button" role="button">
                            <span class="login__company-img">
                              <figure>
                                <svg class="icon--company" style="color: #2bbf57">
                                    <use href="../assets/img/sprite__panels.svg#company"></use>
                                </svg>
                            </figure>

                            </span>
                        <span class="login__company-text" v-html="company.company_name"></span>
                    </button>
                </div>
                <div v-else>
                    <div class="modal-header"><span><i class="fa fa-lock"></i> Log in</span></div>
                    <div class="modal-body text-center">
                        <!--<div class="mb-3">Please enter your username and password</div>-->
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <div class="input-group-text">@</div>
                            </div>
                            <input class="form-control"
                                   type="text"
                                   v-model="email"
                                   placeholder="Username">
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa fa-key"></i></div>
                            </div>
                            <input class="form-control"
                                   type="password"
                                   v-model="password"
                                   placeholder="Password">
                        </div>
                        <button class="btn btn-primary btn-block" @click="onSubmit">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {AUTHORIZATION} from '../constants/constants'

    export default {
  name: 'LoginPage',
  data () {
    return {
      email: '',
      password: '',
      COMPANIES: null
    }
  },
  created () {
    this.$store.dispatch('resetAuth')
  },
  methods: {
    onSubmit (event) {
      event.preventDefault()

      this.$store.dispatch('login', {
        email: this.email,
        password: this.password
      }, {root: true}).then(response => {
        const {data} = response
        if (data && data.success === true) {
          this.$store.dispatch('getCompaniesList',
            localStorage.getItem(AUTHORIZATION), {root: true})
            .then(data => {
              if (data && data.success === true) {
                  this.COMPANIES =data.data.list
              }
            })
        } else {
          this.$toastr.error(data.message)
        }
      }, (error) => {
        if (error.response) {
          this.$toastr.error(error.response.data.message)
        } else {
          this.$toastr.error(error.message)
        }
      })
    },
      loginByCompany (companyId) {
          this.$store.dispatch('loginByCompany',
              {
                  company_id: companyId
              },
              {root: true})
              .then(data => {
                  if (data && data.success === true) {
                      this.$router.push({name: 'Home'})
                  }
              })
      }
  },
  mounted () {
    $(document.body).addClass('bg-img--1')
  },
  beforeDestroy () {
    $(document.body).removeClass('bg-img--1')
  }
}
</script>

<style scoped>
    .login__company {
        width: 100%;
        margin-bottom :5px;
        padding: 15px 3px 1px 3px;
    }
    .login__company-img {
        float: left;
    }
    .login__company-text {
        vertical-align : middle;
    }
    .icon--company {
        height: 30px;
        width: 30px;
    }
</style>
